import { Branding } from "../branding";

export const brandingValues = {
  branding: Branding.Viva,
  httpBrand: "16",
  css: "viva",
  segmentProduct: "viva",
  locale: "", // used in localization - a customization which we use for Walmart but don't want to use for others :)
  partnerName: "Viva Envios",
  logo: "assets/branding/viva/logo.svg", // TODO !!!!!!!!!!!!!!!!!!!!!!!!!!
};



// WEBPACK FOOTER //
// ./src/environment/branding/viva.ts